import { render, staticRenderFns } from "./knowledgeManagement.vue?vue&type=template&id=5bee939f&scoped=true&"
import script from "./knowledgeManagement.vue?vue&type=script&lang=js&"
export * from "./knowledgeManagement.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeManagement.vue?vue&type=style&index=0&id=5bee939f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee939f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bee939f')) {
      api.createRecord('5bee939f', component.options)
    } else {
      api.reload('5bee939f', component.options)
    }
    module.hot.accept("./knowledgeManagement.vue?vue&type=template&id=5bee939f&scoped=true&", function () {
      api.rerender('5bee939f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/knowledgeManagement.vue"
export default component.exports